import '@angular/localize/init';
export * from './lib/feature-tax-vat-list.module';

export * from './lib/tax-vat-list/feature-tax-vat-list.component';
